// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"CarolLotteryDrawButton_actionButton__H2_Ig"};